/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_StorageInputs */

const en_control_planner_storage = /** @type {(inputs: Control_Planner_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser storage is unavailable. You can still plan and share through the URL.`)
};

const zh_control_planner_storage = /** @type {(inputs: Control_Planner_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器存储不可用，仍可通过链接规划和分享。`)
};

/**
* | output |
* | --- |
* | "Browser storage is unavailable. You can still plan and share through the URL." |
*
* @param {Control_Planner_StorageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_storage = /** @type {((inputs?: Control_Planner_StorageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_StorageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_storage(inputs)
	return zh_control_planner_storage(inputs)
});
export { control_planner_storage as "control.planner.storage" }